module.exports = __webpack_public_path__ + "static/media/ct-30.693be62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/ct-30.png
// module id = 88
// module chunks = 0